







































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { IUser, EOrigin, IChain } from '@zunta/configurations'
import Modal from '@/components/Modal.vue'
import Input from '@/components/inputs/Input.vue'
import Select from '@/components/Select.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import { ISelectItem } from '@/interfaces'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import { validateEmail } from '@/utils/helpers'

import Checkbox from '@/components/inputsV2/Checkbox.vue'

@Component({
  props: {
    salesReps: {
      type: Array,
      default: []
    },
    chain: {
      type: Object,
      default: null
    },
    destroyUserAfter: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Checkbox,
    Modal,
    Input,
    Select,
    ErrorMessages
  }
})
export default class AddChainModal extends Vue {
  errors: any = {}
  chainManagerFirstName: string = ''
  chainManagerLastName: string = ''
  chainManagerEmail: string = ''
  chainManagerPhoneNumber: string = ''
  chainManagerPhoneExtension: string = ''
  salesRepresentativeId: number | undefined = undefined
  billingSoftware: string | undefined = undefined
  sandbox: boolean = false
  totalFacilities: number | undefined = undefined;
  facilitiesToOnboard: number | undefined = undefined;
  accountManagerId: number | undefined = undefined;
  name: string = ''
  isAdding: boolean = false
  isFcc: boolean = false

  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  get chainManager () {
    return this.$store.state.user.selectedUser
  }

  get accountManagers () {
    return this.$store.state.user.users
  }

  get salesRepsItems () {
    return this.$props.salesReps.map((user: IUser) => {
      return {
        key: user.id,
        value: user.id,
        content: `${user.firstName} ${user.lastName}`
      }
    })
  }

  get accountManagersItems () {
    return this.accountManagers.map((user: IUser) => {
      return {
        key: user.id,
        value: user.id,
        content: `${user.firstName} ${user.lastName}`
      }
    })
  }

  get billingSoftwareItems () {
    return [
      {
        key: 'BOTH',
        value: 'BOTH',
        content: 'Both'
      },
      ...Object.keys(EOrigin).map((item) => {
        return {
          key: EOrigin[item as keyof typeof EOrigin],
          value: EOrigin[item as keyof typeof EOrigin],
          content: EOrigin[item as keyof typeof EOrigin]
        }
      })
    ]
  }

  changeIsFcc (value: boolean) {
    this.isFcc = value
  }

  changeSandbox (value: boolean) {
    this.sandbox = value
  }

  async mounted () {
    if (this.$props.chain) {
      const chain = this.$props.chain
      this.name = chain.name
      this.salesRepresentativeId = chain.salesRepresentative.id
      await this.userModuleInstance.fetchChainManager(chain.id)
      this.chainManagerFirstName = this.chainManager.firstName
      this.chainManagerLastName = this.chainManager.lastName
      this.chainManagerEmail = this.chainManager.email
      this.billingSoftware = chain.billingSoftware
      this.sandbox = !!chain.sandbox
      this.isFcc = !!chain.isFcc
      this.totalFacilities = chain.totalFacilities
      this.facilitiesToOnboard = chain.facilitiesToOnboard
      if (chain.accountManager) {
        this.accountManagerId = chain.accountManager.id || chain.accountManager
      }
    }
  }

  selectSalesRep (item: ISelectItem) {
    this.salesRepresentativeId = item.value
  }

  selectBillingSoftware (item: ISelectItem) {
    this.billingSoftware = item.value
  }

  selectAccountManger (item: ISelectItem) {
    this.accountManagerId = item.value
    this.$forceUpdate()
  }

  validate () {
    this.errors = {}
    if (!this.salesRepresentativeId) {
      this.errors.salesRepresentativeId = 'Sales Rep. is required'
    }
    if (!this.accountManagerId) {
      this.errors.accountManagerId = 'Account Manager is required'
    }
    if (!this.name) {
      this.errors.name = 'Chain Name is required'
    }
    if (!this.chainManagerFirstName) {
      this.errors.chainManagerFirstName = 'Chain Manager First Name is required'
    }
    if (!this.billingSoftware) {
      this.errors.billingSoftware = 'Billing Software is required'
    }
    if (!this.chainManagerLastName) {
      this.errors.chainManagerLastName = 'Chain Manager Last Name is required'
    }
    if (!this.chainManagerEmail) {
      this.errors.chainManagerEmail = 'Chain Manager Email is required'
    } else if (!validateEmail(this.chainManagerEmail)) {
      this.errors.chainManagerEmail = 'Chain Manager Email must be valid email'
    }
    // @ts-ignore
    this.$refs.billingSoft.validate()
    // @ts-ignore
    this.$refs.salesRep.validate()
    return Object.keys(this.errors).length === 0
  }

  async apply () {
    this.$eventBus.$emit('Input:validate')
    this.$eventBus.$emit('Select:validate')
    if (this.validate()) {
      let result
      this.isAdding = true
      if (this.$props.chain) {
        const payload = {
          id: this.$props.chain.id,
          data: {
            name: this.name,
            salesRepresentative: this.salesRepresentativeId as number,
            sandbox: this.sandbox,
            totalFacilities: this.totalFacilities,
            facilitiesToOnboard: this.facilitiesToOnboard,
            accountManager: this.accountManagerId
          }
        }
        result = await this.chainModuleInstance.updateChain(payload)
      } else {
        const payload = {
          name: this.name,
          salesRepresentativeId: this.salesRepresentativeId as number,
          chainManagerEmail: this.chainManagerEmail,
          chainManagerLastName: this.chainManagerLastName,
          chainManagerFirstName: this.chainManagerFirstName,
          billingSoftware: this.billingSoftware || '',
          isFcc: this.isFcc,
          sandbox: this.sandbox
        }
        result = await this.chainModuleInstance.createChain(payload)
      }
      this.isAdding = false
      if (!result) {
        this.$emit('close')
      } else {
        this.errors.chainManagerEmail = 'Email already in use'
      }
    }
  }

  beforeDestroy () {
    if (this.$props.destroyUserAfter) {
      this.userModuleInstance.resetSelectedUser()
    }
  }
}
